import { useState, useMemo } from 'react';
import moment from 'moment';

const initialTill = moment();
const initialSince = initialTill.clone().subtract(1, 'month');

const useCalendar = () => {
    const [since, setSince] = useState(initialSince);
    const [till, setTill] = useState(initialTill);
    const [focusedInput, setFocusedInput] = useState(null);

    return useMemo(() => ({
        since, setSince,
        till, setTill,
        focusedInput, setFocusedInput,
    }), [since, till, focusedInput]);
}

export default useCalendar;